import React, { useEffect, useRef } from 'react'

import Platform from '../../platforms'
import tts from '../../lib/TTS'
import FocusableButtonTS from '../FocusableButton/FocusableButtonTS'

import type { UrgentMessageModalProps } from './types'
import { useSidePanel } from '../SidePanel/SidePanelProvider'
import googleAnalytics4 from '../../lib/googleAnalytics'
import {
  KeyTypeEnum,
  useKeyDown,
} from '../../../../shared/providers/KeyDownProvider'

const UrgentMessageModal = ({ onCloseModal }: UrgentMessageModalProps) => {
  const modalRef = useRef<HTMLDivElement>(null)
  const { setKeepSidePanelOpened, focusSidePanel, setAvoidStealFocus } =
    useSidePanel()

  const handleDismissPress = () => {
    tts.pushTextToRead('Message dismissed')
    toggleBlur(false)
    onCloseModal()
  }

  useKeyDown(KeyTypeEnum.Back, handleDismissPress, { stopPropagation: true })

  const toggleBlur = (toggleAction) => {
    const sidePanelLayout = document.getElementById(
      'side-panel-layout'
    ) as HTMLElement
    if (sidePanelLayout) {
      sidePanelLayout.style.filter = toggleAction ? 'blur(10px)' : 'none'
    }
  }

  const readMessageContent = () => {
    const { headerText, descriptionText, urlHeaderText, displayUrl } =
      Platform.urgentMessage.details
    tts.addTextToRead(
      `${headerText} ...  ${descriptionText} ... ${urlHeaderText} .... ${displayUrl
        .split('.')
        .join(' dot ')} .... Focussed on Dismiss Button`
    )
  }

  useEffect(() => {
    tts.stopRead()
    //backdrop-filter isnt supported on the devices.
    toggleBlur(true)
    readMessageContent()
    sendUrgentMessageEvent()
    setAvoidStealFocus(true)
    setKeepSidePanelOpened(true)
    return () => {
      setAvoidStealFocus(false)
      setKeepSidePanelOpened(false)
      focusSidePanel()
    }
  }, [])

  const sendUrgentMessageEvent = () => {
    googleAnalytics4.sendCustomEvent('feature_tracking', {
      feature_category: 'urgent messaging',
      feature_name: 'modal',
      object_name: 'modal',
      object_action: 'impression',
      object_action_behavior: 'display content',
    })
  }

  const messageData = Platform.urgentMessage.details
  const headerText = messageData.headerText.replace(/:/g, ':\n')

  return (
    <div className="urgent-message-modal" ref={modalRef}>
      <div className="urgent-message-modal__popup">
        <div className="urgent-message-modal__header">
          <p className="urgent-message-modal__header-text">{headerText}</p>
          <p className="urgent-message-modal__description-text">
            {messageData.descriptionText}
          </p>
        </div>
        <div className="urgent-message-modal__body">
          <p className="urgent-message-modal__url-header-text">
            {messageData.urlHeaderText}
          </p>
          <p className="urgent-message-modal__display-url">
            {messageData.displayUrl}
          </p>
          <img
            className="urgent-message-modal__image"
            src={messageData.qrCodeImageUrl}
            alt="QR Code"
          />
        </div>
        <div className="urgent-message-modal__footer">
          <FocusableButtonTS
            className="urgent-message-modal__close-button"
            onEnterPress={handleDismissPress}
            onFocus={readMessageContent}
            stealFocus={true}
            onArrowPress={() => false}
          >
            <span className="urgent-message-modal__close-button--text">
              Dismiss
            </span>
          </FocusableButtonTS>
        </div>
      </div>
    </div>
  )
}

export default UrgentMessageModal
